import { StorageService } from '@/types/storage';
import { IndexedDBService } from './IndexedDBService';
import { LocalStorageService } from './LocalStorageService';

const isIndexedDBSupported = (): boolean => {
  try {
    // Try to open a dummy database
    const db = window.indexedDB.open('__test__');
    db.onblocked = () => { };
    db.onupgradeneeded = () => { };
    db.onsuccess = () => {
      db.result.close();
      window.indexedDB.deleteDatabase('__test__');
    };
    return true;
  } catch (error) {
    return false;
  }
};

export const storageFactory = {
  createStorageService: (): StorageService => {
    if (isIndexedDBSupported()) {
      return new IndexedDBService();
    } else {
      return new LocalStorageService();
    }
  },
}; 